// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__Kdf6b","cyan":"Button_cyan__BjeWI","dark":"Button_dark__tvhD8","circle":"Button_circle__Q4B2w","square":"Button_square__mzcc8"};